// AdvisorDetails.js
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";

import axios from "axios";
import { API } from "../../API";
import NavBar from "../Navbar";
import { Helmet } from "react-helmet-async";
import "./CategoryContent.css";

const SkeletonCard = () => (
    <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4">
        <div className="card shadow-sm h-100 placeholder-glow">
            <div className="placeholder w-100" style={{ height: "200px" }}></div>
            <div className="card-body">
                <div className="placeholder col-8 mb-2"></div>
                <div className="placeholder col-6"></div>
            </div>
        </div>
    </div>
);

const SocomAdvisorDetails = () => {
    const { advisor_Name } = useParams();

    console.log("ifffffffffff", advisor_Name)
    const [advisor, setAdvisor] = useState({});
    const [channels, setChannels] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchAdvisor = async () => {
            try {
                setLoading(true);
                const { data } = await axios.get(
                    `${API}/api/advisor/by-name_slug/${advisor_Name}`
                );
                console.log("vvvvvvv", data?.data)
                setAdvisor(data?.data || {});
                setChannels(data?.data?.linkedNetworkChannels || []);
                setLoading(false);
            } catch (err) {
                console.error("Advisor fetch failed:", err);
                setLoading(false);
            }
        };

        fetchAdvisor();
    }, [advisor_Name]);
    const generateSlug = (name) => {
        // return name.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "");
        return name
            .toLowerCase()
            .trim()                         // 🔥 remove leading/trailing spaces first
            .replace(/\s+/g, "-")
            .replace(/[^a-z0-9-]/g, "")
            .replace(/-+/g, "-")            // optional: collapse multiple -
            .replace(/^-|-$/g, "");         // 🔥 remove starting & ending -

    };
    return (
        <>
            <Helmet>
                <title>
                    {advisor?.name
                        ? `${advisor.name} - SoCom Advisor`
                        : "SoCom Advisor"}
                </title>
                <meta
                    name="description"
                    content={advisor?.description || "SoCom Advisor profile"}
                />
            </Helmet>

            <NavBar
                categoryLogo={advisor?.logo?.url}
                categoryId={`/socom_advisor/${advisor_Name}`}
            />

            <div className="container py-4">
                {loading ? (
                    <div className="row">
                        {Array.from({ length: 8 }).map((_, i) => (
                            <SkeletonCard key={i} />
                        ))}
                    </div>
                ) : (
                    <>
                        {/* Banner */}
                        {advisor?.banner?.url && (
                            <div className="category-banner mb-4">
                                <img
                                    src={advisor.banner.url}
                                    alt={advisor.name}
                                    className="img-fluid w-100 rounded"
                                />
                            </div>
                        )}

                        {/* Advisor Info */}
                        {/* <div className="mb-5 text-center">
                            <h2 className="fw-bold">{advisor?.name}</h2>
                            <p className="text-muted">{advisor?.description}</p>

                            {advisor?.LinkedIn && (
                                <a
                                    href={advisor.LinkedIn}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="btn btn-outline-primary btn-sm"
                                >
                                    LinkedIn
                                </a>
                            )}
                        </div> */}

                        {/* Channels */}
                        {channels?.length > 0 && (
                            <div className="mb-5">
                                <h4 className="mb-3">Explore Network Channels</h4>
                                <div className="row">
                                    {channels.map((channel) => (
                                        <div
                                            className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4"
                                            key={channel._id}
                                        >
                                            <Link
                                                to={`/net_channel/${generateSlug(channel.name)}`}
                                                className="text-decoration-none"
                                            >
                                                <div className="card shadow-sm h-100">
                                                    <img
                                                        src={channel.thumbnail?.url}
                                                        alt={channel.name}
                                                        className="card-img-top"
                                                        style={{
                                                            height: "180px",
                                                            // objectFit: "cover",
                                                            objectFit: "fill"
                                                        }}
                                                    />
                                                    <div className="card-body">
                                                        <h5 className="card-title text-center text-dark">
                                                            {channel.name}
                                                        </h5>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </>
                )}
            </div>
        </>
    );
};

export default SocomAdvisorDetails;
